exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * @file container/Report/index.less\n * @author fengfaxia(fengfaxia@baidu.com)\n */\n.report-container .chart-container {\n  margin: 20px 0;\n  overflow: hidden;\n}\n.report-container .chart {\n  height: 360px;\n  border: 1px solid #d2d2d2;\n  float: left;\n  width: calc(50% - 10px);\n}\n.report-container .chart:nth-of-type(1) {\n  margin-right: 20px;\n}\n.report-container .report-tip {\n  font-size: 12px;\n  color: red;\n}\n.tooltip-default {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0 10px;\n  display: inline-block;\n  height: 28px;\n  line-height: 28px;\n  box-shadow: none;\n  z-index: 100;\n}\n", ""]);

// exports
